export default "dist/images/block-image-box-plain.d836dfc.png";